import { getProcessEnvironmentValue } from './getProcessEnvironmentValue';
import { ProcessEnv } from '../types';

/* eslint-disable @typescript-eslint/no-empty-function */
// istanbul ignore next
export const noop = () => {};

export const getLang = () => {
  return (getProcessEnvironmentValue('APP_LANG') || 'en') as string;
};

export const getAppView = () => {
  return (getProcessEnvironmentValue('APP_VIEW') || 'web') as string;
};

export const oktaEnvMap: ProcessEnv = {
  local: 'local',
  preview: 'development',
  dev: 'development',
  qa: 'qa',
  beta: 'beta',
  prod: 'production',
};
